// extracted by mini-css-extract-plugin
export var actionButton = "_kd-t";
export var buttonContainer = "_kd-0";
export var buttonContainer2 = "_kd-1";
export var buttonSection = "_kd-2";
export var details = "_kd-3";
export var dropdownItem = "_kd-5";
export var dropdownItemsContainer = "_kd-4";
export var fileInput = "_kd-r";
export var headerButton = "_kd-6";
export var icon = "_kd-7";
export var input = "_kd-8";
export var macroListItem = "_kd-9";
export var mainContent = "_kd-a";
export var microText = "_kd-b";
export var modal = "_kd-w";
export var optionsButton = "_kd-c";
export var paperclip = "_kd-s";
export var pillContent = "_kd-d";
export var preview = "_kd-e";
export var preview2 = "_kd-f";
export var quillEditor = "_kd-q";
export var selectedMacro = "_kd-g";
export var sidebar = "_kd-h";
export var sidebarHeader = "_kd-j";
export var sidebarList = "_kd-i";
export var sidebarListItem = "_kd-k";
export var sidebarSearch = "_kd-l";
export var snoozeDurationWrapper = "_kd-v";
export var statusPillContainer = "_kd-m";
export var tagsContainer = "_kd-n";
export var unselectedMacro = "_kd-o";
export var variable = "_kd-u";
export var wrapper = "_kd-p";